import React, {
  createContext, useContext, useMemo, useState,
} from 'react';
import { HABU_ENVIRONMENT } from 'utils/appConstants';


const EnvironmentFilterContext = createContext();

export const useEnvironmentFilter = () => {
  const context = useContext(EnvironmentFilterContext);
  if (!context) {
    throw new Error('useEnvironmentFilter must be used within an EnvironmentFilterProvider');
  }
  return context;
};

export const EnvironmentFilterProvider = ({ children }) => {
  const defaultEnvironmentFilter = useMemo(() => {
    const isProduction = HABU_ENVIRONMENT === 'production';
    const isStaging = HABU_ENVIRONMENT === 'staging';

    if (isProduction) {
      return 'ALL_ACCOUNTS_FILTER';
    }
    else if (isStaging) {
      return 'DEV_AND_STAGE_FILTER';
    }
    return 'ALL_ACCOUNTS_FILTER'; // default fallback
  }, []);

  const [selectedEnvironmentFilter,
    setSelectedEnvironmentFilter] = useState(defaultEnvironmentFilter);

  const value = {
    selectedEnvironmentFilter,
    setSelectedEnvironmentFilter,
  };

  return (
    <EnvironmentFilterContext.Provider value={value}>
      {children}
    </EnvironmentFilterContext.Provider>
  );
};
